import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "zudoku/hooks";
import { useTenantStore } from "../stores/tenantStore";

export default function useGenerateAPIKey(applicationId, onAPIKeyGenerated) {
    const apiAccessUrl = import.meta.env.ZUDOKU_PUBLIC_APIACCESSMANAGEMENT_FA_URL
    const subscriptionKey = import.meta.env.ZUDOKU_PUBLIC_SUBSCRIPTION_KEY
    const queryClient = useQueryClient();
    const {providerData} = useAuth();
    const token = providerData?.accessToken || providerData?.idToken;

    const tenantCode = useTenantStore((state) => state.currentTenant);
    
    return useMutation({
        mutationFn: async () => {
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    "Authorization": `Bearer ${token}`,
                    "X-NBLY-Tenant-Code": tenantCode,
                    "X-NBLY-Portal-Type": 'participant',
                    "Ocp-Apim-Subscription-Key": subscriptionKey,
                },
                body: JSON.stringify({ tenantCode, applicationId }),
              };

            const response = await fetch(`${apiAccessUrl}/${tenantCode}/applications/${applicationId}/apikey`, options);

            if (!response.ok) {
                throw new Error("Failed to generate Client Secret");
            }

            return response.json();
        },
        onSettled: () => {
            queryClient.invalidateQueries(['GET', `${apiAccessUrl}/${tenantCode}/applications/${applicationId}`]);
        },
        onSuccess: onAPIKeyGenerated
    });
}